(function() {
  if (window.mtQuickWallpaperCalculatorV2Loaded) return;
  window.mtQuickWallpaperCalculatorV2Loaded = true;
  const initializedBoxes = new WeakSet();
  function initWallpaperCalculator(root) {
    let variants = [];
    let optionNames = [];
    let configPromise = null;
    function ensureConfig() {
      if (configPromise) return configPromise;
      configPromise = (async function() {
        let config = null;
        const json = root.querySelector('[data-mt-quick-wallpaper-json]');
        if (json) {
          try { config = JSON.parse(json.textContent); } catch (error) {}
        }
        if (!config || !Array.isArray(config.variants) || !Array.isArray(config.options)) {
          const link = root.querySelector('a.view-full, .product-title a');
          const path = root.dataset.url || (link && link.getAttribute('href'));
          if (!path) throw new Error('Please use View Full Details to calculate your wallpaper.');
          const url = new URL(path, window.location.href);
          if (url.origin !== window.location.origin) throw new Error('Could not load this wallpaper.');
          url.pathname = url.pathname.replace(/\.js$/, '').replace(/\/$/, '') + '.js';
          url.search = '';
          url.hash = '';
          const response = await fetch(url.href, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
          if (!response.ok) throw new Error('Could not load the panel sizes. Please try again.');
          config = await response.json();
        }
        if (!Array.isArray(config.variants) || !Array.isArray(config.options)) throw new Error('Could not read the panel sizes.');
        optionNames = config.options.map(option => typeof option === 'string' ? option : option.name);
        variants = config.variants.map(variant => ({...variant, options: Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].slice(0, optionNames.length)}));
      })().catch(function(error) { configPromise = null; throw error; });
      return configPromise;
    }
    function panelLength(value) {
      const text = String(value).toLowerCase();
      if (/sample|swatch/.test(text)) return null;
      const feet = [...text.matchAll(/(?:^|[^\d.])(4|9|12)\s*(?:[′’']|ft\b|feet\b|foot\b)/g)];
      if (feet.length) return Number(feet[feet.length - 1][1]);
      const inches = [...text.matchAll(/(?:^|[^\d.])(48|108|144)\s*(?:[″”"]|in\b|inches\b)/g)];
      if (inches.length) return Number(inches[inches.length - 1][1]) / 12;
      if (/^\s*(4|9|12)\s*$/.test(text)) return Number(text);
      return null;
    }
    function optionControls(index) {
      const wrapper = root.querySelector('[data-mt-wallpaper-option="' + index + '"]');
      if (wrapper) return [...wrapper.querySelectorAll('input[type="radio"], select')];
      return [];
    }
    function selectedOptions() {
      return optionNames.map(function(name, index) {
        const controls = optionControls(index);
        const select = controls.find(el => el.tagName === 'SELECT');
        const radio = controls.find(el => el.checked);
        return select ? select.value : radio ? radio.value : null;
      });
    }
    function nativeVariantFields() {
      return [...root.querySelectorAll('.formVariantId')];
    }
    root.querySelectorAll('[data-mt-pdp-wallpaper]').forEach(function(box) {
      if (initializedBoxes.has(box)) return;
      initializedBoxes.add(box);
      const $ = selector => box.querySelector(selector);
      const fields = $('[data-wp-fields]');
      const toggle = $('[data-wp-toggle]');
      const result = $('[data-wp-result]');
      const error = $('[data-wp-error]');
      const applied = $('[data-wp-applied]');
      const apply = $('[data-wp-apply]');
      let selection = null;
      let applying = false;
      function fail(message) {
        error.textContent = message;
        error.hidden = false;
      }
      function invalidate() {
        if (applying) return;
        selection = null;
        result.hidden = true;
        error.hidden = true;
        applied.hidden = true;
      }
      toggle.addEventListener('click', function() {
        fields.hidden = !fields.hidden;
        toggle.setAttribute('aria-expanded', String(!fields.hidden));
        toggle.textContent = fields.hidden ? 'use wallpaper calculator' : 'hide wallpaper calculator';
      });
      box.querySelectorAll('input').forEach(input => input.addEventListener('input', invalidate));
      root.addEventListener('change', function(event) {
        if (!box.contains(event.target)) invalidate();
      });
      root.addEventListener('input', function(event) {
        if (!box.contains(event.target)) invalidate();
      });
      root.addEventListener('click', function(event) {
        if (event.target.closest('.qty-selection') && !box.contains(event.target)) invalidate();
      });
      $('[data-wp-calculate]').addEventListener('click', async function() {
        invalidate();
        const inputs = [...box.querySelectorAll('input[type="number"]')];
        if (inputs.some(input => !input.checkValidity() || !Number.isFinite(Number(input.value)))) {
          fail('Enter valid measurements. Inches must be between 0 and 11.'); return;
        }
        const width = Number($('[data-wp-width-ft]').value) * 12 + Number($('[data-wp-width-in]').value);
        const height = Number($('[data-wp-height-ft]').value) * 12 + Number($('[data-wp-height-in]').value);
        if (width <= 0 || height <= 0) { fail('Please enter both wall width and wall height.'); return; }
        if (height > 144) { fail('This wall is taller than our standard 12′ panels. Please contact us for help.'); return; }
        const signature = inputs.map(input => input.value).join('|');
        try { await ensureConfig(); } catch (loadError) { fail(loadError.message); return; }
        if (!box.isConnected || signature !== inputs.map(input => input.value).join('|')) return;
        const sizeIndex = optionNames.findIndex((name, index) => variants.some(variant => panelLength(variant.options[index]) !== null));
        if (sizeIndex < 0) { fail('We could not match the panel lengths. Please choose your size manually or contact us.'); return; }
        const options = selectedOptions();
        const matches = variants.filter(function(variant) {
          const length = panelLength(variant.options[sizeIndex]);
          return variant.available && length && length * 12 >= height && variant.options.every(function(value, index) {
            return index === sizeIndex || !options[index] || value === options[index];
          });
        }).sort((a,b) => panelLength(a.options[sizeIndex]) - panelLength(b.options[sizeIndex]));
        if (!matches.length) { fail('No available panel length fits these measurements and options. Please contact us for help.'); return; }
        selection = { variant: matches[0], panels: Math.ceil(width / 23.5), length: panelLength(matches[0].options[sizeIndex]) };
        $('[data-wp-answer]').textContent = selection.panels + ' panel' + (selection.panels === 1 ? '' : 's') + ' × ' + selection.length + '′';
        result.hidden = false;
      });
      apply.addEventListener('click', function() {
        if (!selection || applying) return;
        const chosen = selection;
        const plans = chosen.variant.options.map(function(value, index) {
          const controls = optionControls(index);
          return controls.find(el => el.tagName === 'SELECT' && [...el.options].some(option => option.value === value)) || controls.find(el => el.value === value);
        });
        const variantFields = nativeVariantFields();
        const cartForms = [...root.querySelectorAll('form.js-prod-form-submit')];
        const qtyFields = [...root.querySelectorAll('.qty-selection input, .formQty, input[name="quantity"]')];
        if (plans.some(control => !control) || !variantFields.length || !cartForms.length || !qtyFields.length) {
          fail('We could not apply these selections. Please choose the roll height and quantity above manually.'); return;
        }
        applying = true;
        apply.disabled = true;
        error.hidden = true;
        plans.forEach(function(control,index) {
          if (control.tagName === 'SELECT') control.value = chosen.variant.options[index];
          else control.checked = true;
          control.dispatchEvent(new Event('change', {bubbles: true}));
        });
        qtyFields.forEach(function(field) {
          field.value = chosen.panels;
          field.dispatchEvent(new Event('input', {bubbles: true}));
          field.dispatchEvent(new Event('change', {bubbles: true}));
        });
        nativeVariantFields().forEach(function(field) {
          field.value = chosen.variant.id;
          field.dispatchEvent(new Event('change', {bubbles: true}));
        });
        cartForms.forEach(function(form) {
          form.querySelectorAll('input[name="quantity"]').forEach(field => field.value = chosen.panels);
        });
        window.setTimeout(function() {
          applying = false;
          apply.disabled = false;
          if (!box.isConnected) return;
          const ids = nativeVariantFields().filter(field => field.name === 'id');
          const liveForms = [...root.querySelectorAll('form.js-prod-form-submit')];
          const nativeOptions = selectedOptions();
          const correct = ids.length && ids.every(field => String(field.value) === String(chosen.variant.id)) &&
            nativeOptions.every((value,index) => value === chosen.variant.options[index]) &&
            liveForms.length && liveForms.every(form => {
              const qty = form.querySelector('input[name="quantity"]');
              return qty && Number(qty.value) === chosen.panels;
            });
          if (!correct) { fail('Please check your roll height and quantity above before adding to cart.'); return; }
          applied.textContent = '✓ Selected: ' + chosen.panels + ' × ' + chosen.length + '′ panels. Ready to add to cart.';
          applied.hidden = false;
          fields.hidden = true;
          toggle.textContent = 'use wallpaper calculator';
          toggle.setAttribute('aria-expanded','false');
        }, 150);
      });
    });
  }
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    const root = node.closest('.js-quickview-wrapper, .product__quickview-wrapper, #quickview-form, .js-quickview-content');
    if (root) initWallpaperCalculator(root);
    node.querySelectorAll('.js-quickview-wrapper').forEach(initWallpaperCalculator);
  }
  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-wp-toggle], [data-wp-calculate], [data-wp-apply]');
    if (!button) return;
    const box = button.closest('[data-mt-pdp-wallpaper]');
    if (!box) return;
    const root = box.closest('.js-quickview-wrapper, .product__quickview-wrapper, #quickview-form, .js-quickview-content');
    if (root) initWallpaperCalculator(root);
  }, true);
  function start() {
    scan(document.documentElement);
    const observer = new MutationObserver(function(records) {
      records.forEach(function(record) {
        record.addedNodes.forEach(scan);
      });
    });
    observer.observe(document.documentElement, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();